const Logo = () => {
  return (
    <div className="logo-image pl-6">
      <div className="text-[24px] font-bold bg-gradient-to-r from-[#00c26f] to-[#0099ff] bg-clip-text text-transparent">
        ササエール
      </div>
    </div>
  );
};

export default Logo;
